module.exports = __webpack_public_path__ + "img/facebook.9d07141d.png";